export default "__VITE_ASSET__DhavtQh$__"